/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import { SvgHandler } from "../../svg-handler/svg-handler";
import searchIcon from "../../../../assets/icons/search.svg";
import { SearchBox } from "../../basic/search-box";
import closeIcon from "../../../../assets/icons/social/close.svg";
import PropTypes from "prop-types";

import "./header-search.m.css";

const DrawForm = ({ children }) => {
  return (
    <div>
      <div styleName="internal-search-wrapper">
        <label htmlFor="searchForm" key="1">
          {children}
        </label>
        <div styleName="search-for-open-form">
          <button styleName="search-redirection">
            <SvgHandler width="24" height="24" xlinkHref={searchIcon} />
          </button>
        </div>
      </div>
    </div>
  );
};

DrawForm.propTypes = {
  children: PropTypes.element
};

const HeaderSearch = props => {
  const { dataTestId, toggleSearchForm, closeAll, hideSearchForm, header = {}, headerType = "" } = props;
  const isSearchFormVisible = header.isSearchFormVisible;

  return (
    <div styleName={`search-wrapper ${headerType}`}>
      <div
        data-test-id={dataTestId}
        styleName={`search-icon ${isSearchFormVisible ? "highlight-search" : ""}`}
        onClick={toggleSearchForm}
      >
        <SvgHandler
          xlinkHref={searchIcon}
          clazzName="search"
          width="24"
          height="24"
          svgWrapperClazzName="svg-wrapper"
        />
      </div>
      {!isSearchFormVisible ? null : (
        <div>
          <SearchBox
            styleName={`search-form search-form--visible`}
            inputId="searchForm"
            inputClassName="search-form-input"
            placeholder="Search Here"
            onSubmitHandler={closeAll}
            onEscape={hideSearchForm}
            template={DrawForm}
          />
          <button styleName="search-close-btn" onClick={hideSearchForm}>
            <SvgHandler xlinkHref={closeIcon} clazzName="close-icon" width="24" height="24" />
          </button>
        </div>
      )}
    </div>
  );
};
HeaderSearch.propTypes = {
  header: PropTypes.object,
  hideSearchForm: PropTypes.func,
  toggleSearchForm: PropTypes.func,
  closeAll: PropTypes.func,
  isSearchFormVisible: PropTypes.bool,
  dataTestId: PropTypes.string,
  headerType: PropTypes.string
};
export { HeaderSearch };
